<div class="dataset-column-table">
    <div class="dataset-column-table__search" *ngIf="!loading && columns.length">
        <input type="text" placeholder="Search columns..." [(ngModel)]="searchTerm"
            aria-label="Search columns" />
    </div>

    <div class="dataset-column-table__loading" *ngIf="loading">Loading columns…</div>

    <div class="dataset-column-table__scroll" *ngIf="!loading">
        <div class="dataset-column-table__head">
            <span class="dataset-column-table__head-cell dataset-column-table__head-cell--check"></span>
            <span class="dataset-column-table__head-cell dataset-column-table__head-cell--name">Column name</span>
            <span class="dataset-column-table__head-cell dataset-column-table__head-cell--type">Type</span>
            <span class="dataset-column-table__head-cell dataset-column-table__head-cell--description">Description</span>
        </div>

        <div class="dataset-column-table__row" [class.dataset-column-table__row--disabled]="!column.selected"
            *ngFor="let column of filteredColumns; trackBy: trackByColumnKey">
            <span class="dataset-column-table__cell dataset-column-table__cell--check">
                <input type="checkbox" [(ngModel)]="column.selected" (ngModelChange)="onSelectionChanged()"
                    [attr.aria-label]="'Include ' + column.name" />
            </span>
            <span class="dataset-column-table__cell dataset-column-table__cell--name">{{ column.name }}</span>
            <span class="dataset-column-table__cell dataset-column-table__cell--type">{{ column.type }}</span>
            <span class="dataset-column-table__cell dataset-column-table__cell--description">{{ column.description }}</span>
        </div>

        <div class="dataset-column-table__empty" *ngIf="!columns.length">
            No columns available for this datasource yet.
        </div>
        <div class="dataset-column-table__empty" *ngIf="columns.length && !filteredColumns.length">
            No columns match your search.
        </div>
    </div>
</div>
